export default __webpack_public_path__ + "static/media/adeolu-eletu.0bac0478.jpg";